@if (icon(); as icon) {
  <svg
    mib-icon
    class="text-mib-branding-900 size-4 shrink-0"
    aria-hidden="true"
    [name]="icon"></svg>
}
<div class="flex min-w-0 flex-1 flex-col">
  <h2 class="text-mib-branding-900 text-mib-sheet truncate font-semibold">
    {{ heading() }}
    <ng-content></ng-content>
  </h2>
</div>
